// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/v-calendar/lib/v-calendar.min.css
// module id = 1477
// module chunks = 173